import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../BaseUrl";
// import { SideBarData } from "../data/leftSideBar";
const initialState = {
  loading: false,
  navData: [
    {
      name: "Overview",
      link: "dashboard",
      rank: 15,
      icon: "home.svg",
      child: [],
    },
    {
      name: "Service Items",
      link: "service-items",
      icon: "service-items.svg",
      rank: 1,
      child: [
        {
          name: "Add Service Items",
          link: "add-item",
          child: [],
        },
      ],
    },
    {
      name: "Services",
      link: "service",
      rank: 2,
      icon: "service.png",
      // type: 'dropDown',
      child: [],
    },
    {
      name: "Service Area",
      link: "service-area",
      rank: 1,
      icon: "service-area.svg",
      // type: 'dropDown',
      child: [],
    },
    {
      name: "Service RFQ List",
      link: "enduser-rfq-list",
      rank: 9,
      //type: "dropDown",
      icon: "rfq-word.svg",
      child: [],
    },
    {
      name: "Provider Management",
      link: "provider",
      rank: 9,
      type: "dropDown",
      icon: "worker.svg",
      child: [
        // {
        //     name: "Approved Member",
        //     link: "approved",
        //     rank: 9,
        //     child: [],
        // },
        //
        // {
        //     name: "Pre Approve Member",
        //     link: "pre-approve",
        //     rank: 7,
        //     child: [],
        // },
        // {
        //     name: "Pending Member",
        //     link: "pending",
        //     rank: 8,
        //     child: [],
        // },
        {
          name: "Provider List",
          link: "provider-list",
          rank: 9,
          child: [],
        },

        // {
        //     name: "Category Request",
        //     link: "category",
        //     rank: 9,
        //     child: [

        //     ],
        // },
        // {
        //     name: "Service Request",
        //     link: "service",
        //     rank: 9,
        //     child: [

        //     ],
        // },

        // {
        //     name: "Area Request",
        //     link: "area",
        //     rank: 9,
        //     child: [
        //     ],
        // },
        {
          name: "Price Management",
          link: "manage-price",
          rank: 9,
          child: [
            // {name: "Approved", link: "approved", rank: 1, child: [] },
            // {name: "Pending", link: "pending", rank: 2, child: [] },
            // {name: "Rejected", link: "rejected", rank: 3, child: [] },
          ],
        },
        // {
        //     name: "Price Request",
        //     link: "price",
        //     rank: 9,
        //     child: [
        //         // {name: "Approved", link: "approved", rank: 1, child: [] },
        //         // {name: "Pending", link: "pending", rank: 2, child: [] },
        //         // {name: "Rejected", link: "rejected", rank: 3, child: [] },
        //     ],
        // },
      ],
    },
    {
      name: "Customer Management",
      link: "EndUser",
      rank: 15,
      icon: "users.svg",
      child: [],
    },
    {
      name: "Order Management",
      link: "order",
      rank: 15,
      icon: "order.svg",
      child: [],
    },
    {
      name: "Tips and Rewards",
      link: "tips-rewards",
      rank: 15,
      icon: "tips.svg",
      child: [],
    },
    {
      name: "Ratings and Reviews",
      link: "ratings",
      rank: 15,
      icon: "ratings.svg",
      child: [],
    },
    {
      name: "Notifications",
      link: "notifications",
      rank: 15,
      icon: "notification.svg",
      type: "dropDown",
      child: [
        {
          name: "All Notifications",
          link: "all-notifications",
          rank: 1,
          icon: "settings.svg",
          child: [],
        },
        {
          name: "Notification Settings",
          link: "notifications-settings",
          rank: 2,
          icon: "settings.svg",
          child: [],
        },
        {
          name: "Notification Category",
          link: "category",
          rank: 3,
          icon: "settings.svg",
          child: [],
        },
        {
          name: "Notification Events",
          link: "notifications-event",
          rank: 4,
          icon: "settings.svg",
          child: [],
        },
      ],
    },
    {
      name: "Dispute Management",
      link: "dispute",
      rank: 15,
      icon: "dispute.svg",
      type: "dropDown",
      child: [
        {
          name: "Dispute Claim List",
          link: "claim-list",
          rank: 1,
          child: [],
        },
        {
          name: "Dispute Setting",
          link: "setting",
          rank: 2,
          child: [],
        },
      ],
    },
    {
      name: "Provider Access Control",
      link: "provider-access-control",
      rank: 15,
      icon: "access-control.svg",
      type: "dropDown",
      child: [
        {
          name: "Provider Module",
          link: "provider-module",
          rank: 1,
          icon: "settings.svg",
          child: [],
        },
        {
          name: "Provider Module Menu",
          link: "menus",
          rank: 2,
          child: [],
        },
        {
          name: "Provider Role",
          link: "provider-role",
          rank: 4,
          icon: "settings.svg",
          child: [],
        },
        // {
        //   name: "Provider Designation",
        //   link: "provider-designation",
        //   rank: 3,
        //   icon: "settings.svg",
        //   child: [],
        // },
        // {
        //   name: "Provider Designation Role",
        //   link: "provider-designation-role",
        //   rank: 5,
        //   icon: "settings.svg",
        //   child: [],
        // },
      ],
    },

    {
      name: "Settings",
      link: "setting",
      rank: 15,
      icon: "settings.svg",
      type: "dropDown",
      child: [
        {
          name: "Item Configuration",
          link: "item-config",
          rank: 2,
          icon: "settings.svg",
          child: [],
        },
        {
          name: "FAQ Management",
          link: "faq",
          rank: 3,
          icon: "settings.svg",
          child: [],
        },
        {
          name: "Manage Device Categories",
          link: "identity",
          rank: 16,
          icon: "settings.svg",
          child: [],
        },
        {
          name: "Interested Categories",
          link: "interested-categories",
          rank: 16,
          icon: "settings.svg",
          child: [],
        },
        {
          name: "Meta Setting",
          link: "meta",
          rank: 16,
          icon: "settings.svg",
          child: [],
        },
        {
          name: "Material Library",
          link: "materials",
          rank: 16,
          icon: "settings.svg",
          child: [],
        },
      ],
    },
     {
      name: "Support Center",
      link: "support",
      rank: 15,
      icon: "dispute.svg",
      type: "dropDown",
      child: [
        {
          name: "Home",
          link: "support-home",
          rank: 1,
          child: [],
        },
        {
          name: "Dispute Setting",
          link: "setting",
          rank: 2,
          child: [],
        },
      ],
    },
    {
      name: "Email Management",
      link: "email-management",
      rank: 16,
      icon: "email.svg",
      type: "dropDown",
      child: [
        {
          name: "Inbox",
          link: "inbox",
          rank: 1,
          child: [],
        },
        {
          name: "Sent Email History",
          link: "sent-history",
          rank: 2,
          child: [],
        },
      ],
    },
    {
      name: "Logout",
      link: "logout",
      rank: 17,
      icon: "logout.svg",
      child: [],
    },
  ],
};

const url = `${BASE_URL}/settings`;

const token = localStorage.getItem("token");
// const textId = localStorage.getItem("textId")

const config = {
  headers: {
    Authorization: `Token ${token}`,
    "content-type": "multipart/form-data",
  },
};

export const addPageMeta = createAsyncThunk(
  "settings/addPageMeta",
  async (formData) => {
    return axios
      .post(`${url}/workerRolePermission/`, formData, config)
      .then((response) => response.data);
  }
);

const navDataSlice = createSlice({
  name: "navData",
  initialState,
  reducers: {
    appendNavBar(state, action) {
      state.navData = action.payload;
    },
    addChildInServiceItem(state, action) {
      // console.log('addChildInServiceItem', action.payload)
      if (action.payload.rank !== 1) {
        state.navData[action.payload.rank].child = [];
      }
      if (action.payload.rank === 1) {
        state.navData[action.payload.rank].child = [
          {
            name: "Add Service Items",
            link: "add-item",
            child: [],
          },
        ];
      }
      if (action.payload.nav !== "") {
        action.payload.nav.forEach((item) => {
          // console.log(item.status, "=======is it nav 1===========");
          if (
            item.status === "Y" ||
            (action.payload.rank === 1 && item.status === "N")
          ) {
            state.navData[action.payload.rank].child.push({
              name: item.title,
              link: `${item.textId}`,
              child: [],
            });
          }
        });
      }
    },

    // addActiveServiceItem(state, action) {
    //   // console.log('addChildInServiceItem',action.payload)
    //   action.payload.nav.forEach((item) => {
    //     state.navData[action.payload.rank].child[item.rank]={
    //       name: item.title,
    //       link: item.textId,
    //       rank: 1,
    //     };
    //   });
    // }
  },
});

export const { appendNavBar, addChildInServiceItem } = navDataSlice.actions;
export default navDataSlice.reducer;
